import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5eb3fb3a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "uil uil-info-circle text-[16px] text-Text/text_low ml-1" }, null, -1))
const _hoisted_4 = { class: "w-[248px]" }
const _hoisted_5 = { class: "w-full p-2 flex justify-end" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Submit ")

import IbxScopedCss from '@/components/IbxScopedCss/IbxScopedCss.vue';
import { IncrediItem, IncrediList, IncrediTooltip, IncrediButton } from 'incredi-ui';
import { useI18n } from 'vue-i18n';
import { useAgentsLicenseConfigurationData } from '@/components/agents-table/AgentActionLicenseConf/AgentActionLicenseConf.helpers';
import { SelectedAgent } from '@/components/agents-table/AgentActionMenu.types';
import { ref } from 'vue';
import { License_RegisterAgentRequest } from '@/graphql/codegen/generated/graphql';


export default /*#__PURE__*/_defineComponent({
  __name: 'InitiatorActionLicenseConf',
  props: {
    agentsList: null
  },
  emits: ["submit"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'submit', newAgentsLicense: License_RegisterAgentRequest[]): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { agentsList: SelectedAgent[] }


const { t } = useI18n();
const { useInitiateConstantData, useInitiateState, getOriginalState } = useAgentsLicenseConfigurationData(props.agentsList);
const { INITIATOR_LICENSE_OPTIONS } = useInitiateConstantData();
const { licenseSelections, licenseAgentRequest } = useInitiateState();
const tooltipObj: { [p: string]: boolean } = {};
INITIATOR_LICENSE_OPTIONS.value.forEach(licenseType => {
  if (licenseType.tooltip) {
    tooltipObj[licenseType.label] = true;
  }
});

const currentInitiatiorSelection = getOriginalState().licenseSelections.initiator;
const tooltipRefs = ref(tooltipObj);
const selectedOption = (label: string) => licenseSelections.value.initiator.label === label;


const submit = () => {
  const request = licenseAgentRequest(props.agentsList);
  emit('submit', request);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(IbxScopedCss, null, {
    default: _withCtx(() => [
      _createVNode(_unref(IncrediList), { class: "pt-[8px] px-[8px] bg-System/app_white !shadow-none !w-[160px] border-b-2" }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(INITIATOR_LICENSE_OPTIONS), (initiatorLicesnseType, index) => {
            return (_openBlock(), _createBlock(_unref(IncrediItem), {
              key: index,
              selected: selectedOption(initiatorLicesnseType.label),
              class: _normalizeClass(initiatorLicesnseType.tooltip ? '!py-[4px]' : ''),
              "data-testid": initiatorLicesnseType.label,
              onClick: ($event: any) => (_unref(licenseSelections).initiator = initiatorLicesnseType)
            }, {
              default: _withCtx(() => [
                (!initiatorLicesnseType.tooltip || _unref(currentInitiatiorSelection).label === initiatorLicesnseType.label)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(initiatorLicesnseType.label), 1))
                  : (_openBlock(), _createBlock(_unref(IncrediTooltip), {
                      key: 1,
                      modelValue: tooltipRefs.value[initiatorLicesnseType.label],
                      "onUpdate:modelValue": ($event: any) => ((tooltipRefs.value[initiatorLicesnseType.label]) = $event),
                      hover: "",
                      direction: "middle-right",
                      delay: 200
                    }, {
                      content: _withCtx(() => [
                        _createVNode(IbxScopedCss, null, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(t)('agentsTable.licenseConfig.initiatorNotes.tooltip')), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("div", {
                          class: "row items-center",
                          onClick: ($event: any) => (_unref(licenseSelections).initiator = initiatorLicesnseType)
                        }, [
                          _createTextVNode(_toDisplayString(initiatorLicesnseType.label) + " ", 1),
                          _hoisted_3
                        ], 8, _hoisted_2)
                      ]),
                      _: 2
                    }, 1032, ["modelValue", "onUpdate:modelValue"]))
              ]),
              _: 2
            }, 1032, ["selected", "class", "data-testid", "onClick"]))
          }), 128))
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_unref(IncrediButton), {
          design: "primary-green",
          size: "tiny",
          class: "w-[60px]",
          "data-testid": "set-initiator-role-submit",
          disabled: _unref(currentInitiatiorSelection).label === _unref(licenseSelections).initiator.label,
          onClick: submit
        }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        }, 8, ["disabled"])
      ])
    ]),
    _: 1
  }))
}
}

})